import { Component, EventEmitter, Inject, OnInit, Output, ChangeDetectionStrategy } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { IPermission } from '@core/interfaces/ipermission'
import { TranslocoService } from '@jsverse/transloco'

@Component({
    selector: 'drdp-features-add-edit',
    templateUrl: './features-add-edit.component.html',
    styleUrls: ['./features-add-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FeaturesAddEditComponent implements OnInit {
  @Output() valueChange = new EventEmitter();
  featureForm: FormGroup | any;
  headerName = '';

  get permissionName() { return this.featureForm.get('permissionName') };
  get permissionDescription() { return this.featureForm.get('permissionDescription') };

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<FeaturesAddEditComponent>,
    @Inject(MAT_DIALOG_DATA) public editData: any,
    private translocoService: TranslocoService,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.initializeForms();
  }

  initializeForms(): void {
    this.headerName = this.translocoService.translate('accounts.features.addFeature');
    this.featureForm = this.fb.group({
      permissionName: [null, Validators.required],
      permissionDescription: [null, Validators.required],
    });

    if (this.editData) {
      const edit = this.editData.data
      this.headerName = this.translocoService.translate('accounts.features.editFeature');
      this.permissionName.setValue(edit.permissionName)
      this.permissionDescription.setValue(edit.permissionDescription)
    };
  }

  onSubmit() {
    let payload: IPermission = this.featureForm.value;

    if (this.editData) {
      const { id } = this.editData.data;
      payload.id = id;
    }

    return {
      formValid: true,
      payload: payload
    };
  }
}
